import React from 'react';
import Backdrop from '@mui/material/Backdrop';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import { useSelector } from 'react-redux';
import type { RootState } from '../../store/store';

const LoadingOverlay: React.FC = () => {
	const loading = useSelector((state: RootState) => state.visaProgram.loading || state.idealCountry.loading);

	return (
		<Backdrop
			open={loading}
			sx={{
				color: '#fff',
				zIndex: (theme) => theme.zIndex.drawer + 9999,
				flexDirection: 'column',
				backdropFilter: 'blur(2px)',
			}}
			aria-label="Loading overlay"
		>
			<Box sx={{ width: '50vw', maxWidth: 400 }}>
				<LinearProgress color="success" />
			</Box>
		</Backdrop>
	);
};

export default LoadingOverlay;
